import { ReactNode, useMemo } from 'react'
import { createHtmlPortalNode, InPortal } from 'react-reverse-portal'
import { AlertProvider, BlobBackground } from '../rapid-ui'
import { MainNavConfig, MainNavPortalTargetContext, ProvidedMainNavConfigContext } from './main-nav-context'
import { PortalMainNav } from './portal-main-nav'
import { ProvidedSettingsNavConfigContext, ProvidedSettingsNavConfigContextType } from './settings-config-context'

export type CommonUiProviderProps = {
	children: ReactNode
	mainNav: MainNavConfig
	settingsNav: ProvidedSettingsNavConfigContextType

	orgSwitcher: ReactNode
}

export function CommonUiProvider(
	props: CommonUiProviderProps,
) {
	const portalNode = useMemo(() => createHtmlPortalNode(), [])

	const value = useMemo(() => ({ mainNavTargetNode: portalNode }), [portalNode])

	return (
		<AlertProvider>
			<ProvidedMainNavConfigContext.Provider
				value={{ ...props.mainNav, orgSwitcher: props.orgSwitcher }}
			>
				<ProvidedSettingsNavConfigContext.Provider value={props.settingsNav}>
					<InPortal node={portalNode}>
						<PortalMainNav />
					</InPortal>
					<MainNavPortalTargetContext.Provider value={value}>
						<BlobBackground />
						{props.children}
					</MainNavPortalTargetContext.Provider>
				</ProvidedSettingsNavConfigContext.Provider>
			</ProvidedMainNavConfigContext.Provider>
		</AlertProvider>
	)
}
